// extracted by mini-css-extract-plugin
export default {"icons":"PriceCards_icons__ggoE+","greyText":"PriceCards_greyText__0TuGf"};